import { useQuery, useQueryClient } from "@tanstack/react-query";

import { getFootprintingPorkManureAdditive, getFootprintingPorkManureAdditiveAdmin } from "services";

import { getEnvironment } from "utils";

import { FOOTPRINTING_PORK_MANURE_ADDITIVE } from "consts";

export const useGetFootprintingPorkManureAdditive = (primaryDataId?: string) => {
  const isAdmin = getEnvironment().admin;
  const queryClient = useQueryClient();
  return useQuery(
    {
      queryKey: [FOOTPRINTING_PORK_MANURE_ADDITIVE, primaryDataId, isAdmin],
      queryFn: () => (isAdmin ? getFootprintingPorkManureAdditiveAdmin(primaryDataId ?? "") : getFootprintingPorkManureAdditive(primaryDataId ?? "")),
      enabled: !!primaryDataId,
      gcTime: 0,
    },
    queryClient
  );
};
